import { InputTextDesignTokens } from '@primeuix/themes/types/inputtext';

import { getColor, getRem } from '@customer-portal/shared/helpers/theme-utils';

export const inputTextOverride: InputTextDesignTokens = {
  root: {
    placeholderColor: getColor('PlaceholderGray'),
    borderRadius: getRem(8),
    borderColor: getColor('Sandstone80'),
    invalidBorderColor: getColor('Sandstone80'),
    invalidPlaceholderColor: getColor('PlaceholderGray'),
  },
};
